"use strict"; // Copyright 2019 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var google_auth_library_1 = require("google-auth-library");

var AuthPlus =
/*#__PURE__*/
function (_google_auth_library_) {
  _inherits(AuthPlus, _google_auth_library_);

  function AuthPlus() {
    var _this;

    _classCallCheck(this, AuthPlus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthPlus).apply(this, arguments)); // tslint:disable-next-line: variable-name

    _this.JWT = google_auth_library_1.JWT; // tslint:disable-next-line: variable-name

    _this.Compute = google_auth_library_1.Compute; // tslint:disable-next-line: variable-name

    _this.OAuth2 = google_auth_library_1.OAuth2Client; // tslint:disable-next-line: variable-name

    _this.GoogleAuth = google_auth_library_1.GoogleAuth;
    return _this;
  }
  /**
   * Override getClient(), memoizing an instance of auth for
   * subsequent calls to getProjectId().
   */


  _createClass(AuthPlus, [{
    key: "getClient",
    value: function () {
      var _getClient = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._cachedAuth = new google_auth_library_1.GoogleAuth(options);
                return _context.abrupt("return", this._cachedAuth.getClient());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getClient(_x) {
        return _getClient.apply(this, arguments);
      }

      return getClient;
    }()
  }, {
    key: "getProjectId",
    value: function getProjectId(callback) {
      if (callback) {
        return this._cachedAuth ? this._cachedAuth.getProjectId(callback) : _get(_getPrototypeOf(AuthPlus.prototype), "getProjectId", this).call(this, callback);
      } else {
        return this._cachedAuth ? this._cachedAuth.getProjectId() : _get(_getPrototypeOf(AuthPlus.prototype), "getProjectId", this).call(this);
      }
    }
  }]);

  return AuthPlus;
}(google_auth_library_1.GoogleAuth);

exports.AuthPlus = AuthPlus;